<script setup lang="ts">
const uiStore = useUIStore()
const props = defineProps(['resetToken', 'login'])

onMounted(() => {
  uiStore.isShowResetPasswordModal = true

  const url = new URL(window.location.href)
  ;['resetToken', 'activation', 'login'].forEach((param: string) => url.searchParams.delete(param))
  window.history.replaceState({}, '', url)
})
</script>

<template>
  <div>
    <Modal
      :show="uiStore.isShowResetPasswordModal"
      @close="uiStore.isShowResetPasswordModal = false"
      class="reset-password-modal__modal"
      data-testid="reset-password-modal"
    >
      <ResetPassword @close="uiStore.isShowResetPasswordModal = false" :reset-token="resetToken" :login="login" />
    </Modal>
  </div>
</template>
